import TYPE from './type.js'

// 54 place-type resources theo IAM_INTEGRATION.md
const IAM_PLACE_TYPES = [
  'activity', 'area', 'attraction', 'buddhist-learning', 'buddhist-scripture', 'campaign',
  'cemetery', 'church', 'commerce', 'commerce-tour', 'company', 'contact', 'country',
  'craft-village', 'cuisine', 'dashboard', 'document', 'document-library', 'entertainment',
  'event', 'family', 'festival', 'financial', 'golf', 'government-agency', 'health', 'image',
  'image-library', 'kiosk', 'lookup', 'museum', 'music', 'news', 'other', 'people',
  'policy-communication', 'post', 'press', 'qna', 'real-estate', 'refuge', 'restaurant',
  'reviewer', 'sound-library', 'stay', 'tour', 'tour-guide', 'trade', 'traffic',
  'transportation', 'travel-experience', 'video', 'video-library', 'volunteer'
]

// 0. RESOURCE ENDPOINTS
export const RESOURCE_ENDPOINTS = {
  // Place & Điểm đến
  PLACE: '/place',
  PLACE_LIST: '/place/list',
  PLACE_ENABLE: '/place/enable',
  PLACE_GROUP: '/place/group',
  PLACE_GROUP_ITEM: '/place/group/item',
  PLACE_GROUP_LIST: '/place/group/list',
  PLACE_CATEGORIES: '/place_categories',
  PLACE_FACILITIES: '/place_facilities',
  PLACE_FACILITY_GROUPS: '/place_facility_groups',
  PLACE_RATINGS: '/place_ratings',
  PLACE_RELATED: '/place_related',
  PLACE_SERVICES: '/place_services',
  PLACE_ARTIFACT: '/place/artifact',
  PLACE_MENU: '/place/menu',
  PLACE_REELS: '/place_reels',

  // Actions, Logs & Analytics
  ACTIONS: '/actions',
  ACTIVITY_LOGS: '/activity-logs',
  ANALYTICS: '/analytics',

  // Artifact
  ARTIFACT: '/artifact',
  ARTIFACT_CLASSIFICATION: '/artifact/classification',
  ARTIFACT_LIST: '/artifact/list',

  // Banner
  BANNERS: '/banners',

  // Board
  BOARD_ITEMS: '/board-items',
  BOARD_ITEMS_CHECK: '/board-items/check',
  BOARDS: '/boards',

  // Campaign & Promotion
  CAMPAIGN: '/campaign',
  CAMPAIGN_LIST: '/campaign/list',
  PROMOTION: '/promotion',

  // Comment
  COMMENT: '/comment',
  COMMENT_LIST: '/comment/list',

  // Constant
  CONSTANT: '/constant',

  // Department & Working Location
  DEPARTMENT: '/department',
  WORKING_LOCATION: '/working_location',

  // Dish
  DISH: '/dish',
  DISH_GROUP: '/dish_group',
  DISH_SIZE_GROUP: '/dish_size_group',
  DISH_SUBSCRIPTION: '/dish_subscription',

  // Display Models
  DISPLAY_MODELS: '/display_models',

  // Goong Map
  GOONG_AUTOCOMPLETE: '/goong/autocomplete',
  GOONG_DETAIL: '/goong/detail',

  // Group
  GROUP: '/group',
  GROUP_ITEM: '/group/item',

  // Hierarchy
  HIERARCHY: '/hierarchy',
  HIERARCHY_ITEM: '/hierarchy_item',

  // Likes
  LIKES: '/likes',

  // Organizations & Phân quyền
  ORGANIZATIONS: '/organizations',
  ORGANIZATION_ACTIONS: '/organization_actions',
  ORGANIZATION_ACTION_ASSIGNEES: '/organization_action_assignees',
  ORGANIZATIONS_ADD_ADMIN: '/organizations/add-admin',
  ORGANIZATIONS_ADD_MEMBER: '/organizations/add-member',
  ORGANIZATIONS_ADD_OWNER: '/organizations/add-owner',
  ORGANIZATIONS_APPOINT_OWNER: '/organizations/appoint-owner',
  ORGANIZATIONS_REMOVE_MEMBER: '/organizations/remove-member',

  // Package
  PACKAGE: '/package',
  PACKAGE_PLACE: '/package/place',

  // Payment & Receipt
  PAYMENT_BALANCE: '/payment/balance',
  RECEIPT: '/receipt',
  RECEIPT_STATISTIC: '/receipt/statistic',

  // Room Type
  ROOM_TYPE: '/room-type',
  ROOM_TYPE_LIST: '/room-type/list',

  // Storage
  STORAGE: '/storage',
  STORAGE_CHANGE_ORDER: '/storage/change-order',
  STORAGE_LIST: '/storage/list',
  STORAGE_URL: '/storage/url',

  // Tag
  TAG: '/tag',

  // Tour
  TOUR_DAY: '/tour-day',
  TOUR_DAY_LIST: '/tour-day/list',
  TOUR_DES: '/tour-des',
  TOUR_DES_LIST: '/tour-des/list',

  // User
  USER: '/user',
  USER_LIST: '/user/list',
  USER_RESET_PASSWORD: '/user/reset_password',
  USER_REGISTER_FORMS: '/user_register_forms',

  // System & Other
  CODE: '/code',
  CURRENT_ATTEMPT: '/current_attempt',
  CURRENT_ATTEMPT_RESET: '/current_attempt/reset',
  FORCE_LOGOUT: '/force_logout',
  MANAGED_RESOURCES: '/managed_resources',
  MENU_ITEM: '/menu-item',
  MENU_ITEM_LIST: '/menu-item/list',
  MODEL_TAG: '/model-tag',
  RECORD_UTILS_COUNT: '/record-utils/count',
  RECORD_UTILS_QUERY_DOCS: '/record-utils/query-docs',
  RECORD_UTILS_SUPPORT_TYPES: '/record-utils/support-types'
}

export const RESOURCE_ENDPOINT = RESOURCE_ENDPOINTS
export const ENDPOINT = RESOURCE_ENDPOINTS
export const ENDPOINTS = RESOURCE_ENDPOINTS

// 1. PLACE RESOURCES (endpoint = '/place', mỗi resource_type là 1 loại điểm đến từ IAM_PLACE_TYPES)
export const PLACE_RESOURCES = IAM_PLACE_TYPES.map((type) => {
  const place = (TYPE.PLACES || []).find((p) => p.value === type)
  return {
    name: (place && place.name) || type,
    endpoint: RESOURCE_ENDPOINTS.PLACE,
    resource_type: type,
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  }
})

// 2. PLACE LIST RESOURCE (endpoint = '/place/list' trong backend là resource API chung, không phân theo 54 resource_type)
export const PLACE_LIST_RESOURCES = [
  {
    name: 'Danh sách điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_LIST,
    resource_type: 'API',
    actions: ['GET'],
    required: true
  }
]

// 3. API RESOURCES (resource_type = 'API', theo danh mục seeded và bảng Enforced trong IAM_INTEGRATION.md)
export const API_RESOURCES = [
  {
    name: 'Hành động phân quyền',
    endpoint: RESOURCE_ENDPOINTS.ACTIONS,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Nhật ký hoạt động',
    endpoint: RESOURCE_ENDPOINTS.ACTIVITY_LOGS,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Thống kê phân tích',
    endpoint: RESOURCE_ENDPOINTS.ANALYTICS,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Danh sách',
    endpoint: RESOURCE_ENDPOINTS.ARTIFACT,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Nhóm danh sách',
    endpoint: RESOURCE_ENDPOINTS.ARTIFACT_CLASSIFICATION,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'List - Danh sách',
    endpoint: RESOURCE_ENDPOINTS.ARTIFACT_LIST,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Trang Banner',
    endpoint: RESOURCE_ENDPOINTS.BANNERS,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Hạng mục danh sách yêu thích',
    endpoint: RESOURCE_ENDPOINTS.BOARD_ITEMS,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'DELETE']
  },
  {
    name: 'Danh sách yêu thích (Boards)',
    endpoint: RESOURCE_ENDPOINTS.BOARDS,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Chương trình KM',
    endpoint: RESOURCE_ENDPOINTS.CAMPAIGN,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Danh sách chương trình KM',
    endpoint: RESOURCE_ENDPOINTS.CAMPAIGN_LIST,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Bình luận',
    endpoint: RESOURCE_ENDPOINTS.COMMENT,
    resource_type: 'API',
    actions: ['CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Danh sách bình luận',
    endpoint: RESOURCE_ENDPOINTS.COMMENT_LIST,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Hằng số hệ thống',
    endpoint: RESOURCE_ENDPOINTS.CONSTANT,
    resource_type: 'API',
    actions: ['GET'],
    required: true
  },
  {
    name: 'Phòng ban',
    endpoint: RESOURCE_ENDPOINTS.DEPARTMENT,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Món ăn',
    endpoint: RESOURCE_ENDPOINTS.DISH,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Nhóm món ăn',
    endpoint: RESOURCE_ENDPOINTS.DISH_GROUP,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Nhóm kích cỡ món',
    endpoint: RESOURCE_ENDPOINTS.DISH_SIZE_GROUP,
    resource_type: 'API',
    actions: ['CREATE']
  },
  {
    name: 'Đăng ký món ăn',
    endpoint: RESOURCE_ENDPOINTS.DISH_SUBSCRIPTION,
    resource_type: 'API',
    actions: ['GET', 'UPDATE']
  },
  {
    name: 'Mô hình hiển thị',
    endpoint: RESOURCE_ENDPOINTS.DISPLAY_MODELS,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Goong Map: Gợi ý điểm đến',
    endpoint: RESOURCE_ENDPOINTS.GOONG_AUTOCOMPLETE,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Goong Map: Chi tiết điểm đến',
    endpoint: RESOURCE_ENDPOINTS.GOONG_DETAIL,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Nhóm liên kết',
    endpoint: RESOURCE_ENDPOINTS.GROUP,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Mục liên kết',
    endpoint: RESOURCE_ENDPOINTS.GROUP_ITEM,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Phân hệ (Hierarchy)',
    endpoint: RESOURCE_ENDPOINTS.HIERARCHY,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Hạng mục phân hệ',
    endpoint: RESOURCE_ENDPOINTS.HIERARCHY_ITEM,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Lượt yêu thích',
    endpoint: RESOURCE_ENDPOINTS.LIKES,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Tổ chức',
    endpoint: RESOURCE_ENDPOINTS.ORGANIZATIONS,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'White list tài khoản',
    endpoint: RESOURCE_ENDPOINTS.ORGANIZATION_ACTION_ASSIGNEES,
    resource_type: 'API',
    actions: ['CREATE', 'DELETE']
  },
  {
    name: 'Phân quyền tài khoản của tổ chức',
    endpoint: RESOURCE_ENDPOINTS.ORGANIZATION_ACTIONS,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Tài khoản admin',
    endpoint: RESOURCE_ENDPOINTS.ORGANIZATIONS_ADD_ADMIN,
    resource_type: 'API',
    actions: ['CREATE', 'UPDATE']
  },
  {
    name: 'Tài khoản thành viên',
    endpoint: RESOURCE_ENDPOINTS.ORGANIZATIONS_ADD_MEMBER,
    resource_type: 'API',
    actions: ['CREATE', 'UPDATE']
  },
  {
    name: 'Tài khoản chủ sở hữu',
    endpoint: RESOURCE_ENDPOINTS.ORGANIZATIONS_ADD_OWNER,
    resource_type: 'API',
    actions: ['CREATE', 'UPDATE']
  },
  {
    name: 'Bổ nhiệm chủ sở hữu',
    endpoint: RESOURCE_ENDPOINTS.ORGANIZATIONS_APPOINT_OWNER,
    resource_type: 'API',
    actions: ['CREATE', 'UPDATE']
  },
  {
    name: 'Xóa thành viên',
    endpoint: RESOURCE_ENDPOINTS.ORGANIZATIONS_REMOVE_MEMBER,
    resource_type: 'API',
    actions: ['CREATE', 'UPDATE']
  },
  {
    name: 'Gói dịch vụ (Package)',
    endpoint: RESOURCE_ENDPOINTS.PACKAGE,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Public điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_ENABLE,
    resource_type: 'API',
    actions: ['ENABLE']
  },
  {
    name: 'Nhóm điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_GROUP,
    resource_type: 'API',
    actions: ['CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Mục trong nhóm điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_GROUP_ITEM,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Danh sách nhóm điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_GROUP_LIST,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Danh mục điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_CATEGORIES,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Tiện ích điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_FACILITIES,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Nhóm tiện ích điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_FACILITY_GROUPS,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Đánh giá điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_RATINGS,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Danh sách liên kết',
    endpoint: RESOURCE_ENDPOINTS.PLACE_RELATED,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Dịch vụ điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_SERVICES,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Hạng phòng',
    endpoint: RESOURCE_ENDPOINTS.ROOM_TYPE,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Danh sách hạng phòng',
    endpoint: RESOURCE_ENDPOINTS.ROOM_TYPE_LIST,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Kho lưu trữ',
    endpoint: RESOURCE_ENDPOINTS.STORAGE,
    resource_type: 'API',
    actions: ['CREATE', 'UPDATE']
  },
  {
    name: 'Đổi thứ tự tệp',
    endpoint: RESOURCE_ENDPOINTS.STORAGE_CHANGE_ORDER,
    resource_type: 'API',
    actions: ['CREATE']
  },
  {
    name: 'Danh sách tệp lưu trữ',
    endpoint: RESOURCE_ENDPOINTS.STORAGE_LIST,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Lưu trữ tệp bằng đường dẫn',
    endpoint: RESOURCE_ENDPOINTS.STORAGE_URL,
    resource_type: 'API',
    actions: ['CREATE']
  },
  {
    name: 'Thẻ Tag',
    endpoint: RESOURCE_ENDPOINTS.TAG,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Lịch trình Tour',
    endpoint: RESOURCE_ENDPOINTS.TOUR_DAY,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Danh sách lịch trình Tour',
    endpoint: RESOURCE_ENDPOINTS.TOUR_DAY_LIST,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Điểm đến trong lịch trình',
    endpoint: RESOURCE_ENDPOINTS.TOUR_DES,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Người dùng',
    endpoint: RESOURCE_ENDPOINTS.USER,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  },
  {
    name: 'Danh sách người dùng',
    endpoint: RESOURCE_ENDPOINTS.USER_LIST,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Đặt lại mật khẩu người dùng',
    endpoint: RESOURCE_ENDPOINTS.USER_RESET_PASSWORD,
    resource_type: 'API',
    actions: ['UPDATE']
  },
  {
    name: 'Biểu mẫu đăng ký (Hỗ trợ)',
    endpoint: RESOURCE_ENDPOINTS.USER_REGISTER_FORMS,
    resource_type: 'API',
    actions: ['GET']
  },
  {
    name: 'Nơi làm việc',
    endpoint: RESOURCE_ENDPOINTS.WORKING_LOCATION,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE']
  }
]

// 4. HIDDEN API RESOURCES (các API nội bộ/hệ thống có hide = true)
export const HIDDEN_API_RESOURCES = [
  {
    name: 'Kiểm tra mục yêu thích',
    endpoint: RESOURCE_ENDPOINTS.BOARD_ITEMS_CHECK,
    resource_type: 'API',
    actions: ['CREATE'],
    hide: true
  },
  {
    name: 'Mã giới thiệu (Giftcode)',
    endpoint: RESOURCE_ENDPOINTS.CODE,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE'],
    hide: true
  },
  {
    name: 'Lượt làm bài hiện tại',
    endpoint: RESOURCE_ENDPOINTS.CURRENT_ATTEMPT,
    resource_type: 'API',
    actions: ['GET'],
    hide: true
  },
  {
    name: 'Đặt lại lượt thi',
    endpoint: RESOURCE_ENDPOINTS.CURRENT_ATTEMPT_RESET,
    resource_type: 'API',
    actions: ['CREATE'],
    hide: true
  },
  {
    name: 'Đăng xuất bắt buộc',
    endpoint: RESOURCE_ENDPOINTS.FORCE_LOGOUT,
    resource_type: 'API',
    actions: ['CREATE'],
    hide: true
  },
  {
    name: 'Tài nguyên quản lý',
    endpoint: RESOURCE_ENDPOINTS.MANAGED_RESOURCES,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE'],
    hide: true
  },
  {
    name: 'Mục Menu',
    endpoint: RESOURCE_ENDPOINTS.MENU_ITEM,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE'],
    hide: true
  },
  {
    name: 'Danh sách mục Menu',
    endpoint: RESOURCE_ENDPOINTS.MENU_ITEM_LIST,
    resource_type: 'API',
    actions: ['GET'],
    hide: true
  },
  {
    name: 'Thẻ mô hình',
    endpoint: RESOURCE_ENDPOINTS.MODEL_TAG,
    resource_type: 'API',
    actions: ['GET'],
    hide: true
  },
  {
    name: 'Điểm đến trong gói',
    endpoint: RESOURCE_ENDPOINTS.PACKAGE_PLACE,
    resource_type: 'API',
    actions: ['GET', 'DELETE'],
    hide: true
  },
  {
    name: 'Số dư thanh toán',
    endpoint: RESOURCE_ENDPOINTS.PAYMENT_BALANCE,
    resource_type: 'API',
    actions: ['GET'],
    hide: true
  },
  {
    name: 'Hiện vật điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_ARTIFACT,
    resource_type: 'API',
    actions: ['GET'],
    hide: true
  },
  {
    name: 'Thực đơn điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_MENU,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE'],
    hide: true
  },
  {
    name: 'Video ngắn điểm đến',
    endpoint: RESOURCE_ENDPOINTS.PLACE_REELS,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE'],
    hide: true
  },
  {
    name: 'Khuyến mãi',
    endpoint: RESOURCE_ENDPOINTS.PROMOTION,
    resource_type: 'API',
    actions: ['CREATE', 'UPDATE', 'DELETE'],
    hide: true
  },
  {
    name: 'Biên lai / Đơn hàng',
    endpoint: RESOURCE_ENDPOINTS.RECEIPT,
    resource_type: 'API',
    actions: ['GET', 'CREATE', 'UPDATE', 'DELETE'],
    hide: true
  },
  {
    name: 'Thống kê biên lai',
    endpoint: RESOURCE_ENDPOINTS.RECEIPT_STATISTIC,
    resource_type: 'API',
    actions: ['GET'],
    hide: true
  },
  {
    name: 'Thống kê số lượng',
    endpoint: RESOURCE_ENDPOINTS.RECORD_UTILS_COUNT,
    resource_type: 'API',
    actions: ['CREATE'],
    hide: true
  },
  {
    name: 'Thống kê tài liệu',
    endpoint: RESOURCE_ENDPOINTS.RECORD_UTILS_QUERY_DOCS,
    resource_type: 'API',
    actions: ['GET'],
    hide: true
  },
  {
    name: 'Loại hỗ trợ',
    endpoint: RESOURCE_ENDPOINTS.RECORD_UTILS_SUPPORT_TYPES,
    resource_type: 'API',
    actions: ['GET'],
    hide: true
  },
  {
    name: 'Danh sách điểm đến trong lịch trình',
    endpoint: RESOURCE_ENDPOINTS.TOUR_DES_LIST,
    resource_type: 'API',
    actions: ['GET'],
    hide: true
  }
]

// 5. TOÀN BỘ RESOURCES TRONG HỆ THỐNG
export const RESOURCES = [
  ...PLACE_RESOURCES,
  ...PLACE_LIST_RESOURCES,
  ...API_RESOURCES
]

export default {
  RESOURCE_ENDPOINTS,
  RESOURCE_ENDPOINT,
  ENDPOINT: RESOURCE_ENDPOINTS,
  ENDPOINTS: RESOURCE_ENDPOINTS,
  PLACE_RESOURCES,
  PLACE_LIST_RESOURCES,
  API_RESOURCES,
  HIDDEN_API_RESOURCES,
  RESOURCES
}
